// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import reduxDynamicMiddlewares from 'redux-dynamic-middlewares'

import { asyncDataFetchMiddleware } from '@buffer-mono/async-data-fetch'
import { middleware as notificationsMiddleware } from '@buffer-mono/legacy-bufferapp-notifications'

import queueMiddleware from '~publish/legacy/queue/middleware'
import draftsMiddleware from '~publish/legacy/drafts/middleware'
import generalSettingsMiddleware from '~publish/legacy/general-settings/middleware'
import profileSidebarMiddleware from '~publish/legacy/profile-sidebar/middleware'
import bootstrapMiddleware from '~publish/legacy/bootstrap/middleware'
import i18nMiddleware from '~publish/legacy/i18n/middleware'
import pusherSyncMiddleware from '~publish/legacy/pusher-sync/middleware'
import modalsMiddleware from '~publish/legacy/modals/middleware'
import maintenanceRedirectMiddleware from '~publish/legacy/maintenance-redirect/middleware'
import notificationsProviderMiddleware from '~publish/legacy/notifications-provider/middleware'
import profilesDisconnectedModalMiddleware from '~publish/legacy/profiles-disconnected-modal/middleware'
import campaignFormMiddleware from '~publish/legacy/campaign-form/middleware'
import campaignMiddleware from '~publish/legacy/campaign/middleware'
import campaignsListMiddleware from '~publish/legacy/campaigns-list/middleware'
import deleteCampaignModalMiddleware from '~publish/legacy/delete-campaign-modal/middleware'
import trialCompleteModalMiddleware from '~publish/legacy/trial-complete-modal/middleware'
import hashtagGroupsMiddleware from '~publish/legacy/hashtag-group-manager/middleware'
import segmentTrackingMiddleware from '~publish/legacy/analytics-middleware/middleware'
import globalAccountMiddleware from '~publish/legacy/globalAccount/middleware'
import temporaryBannerMiddleware from '~publish/legacy/temporary-banner/middleware'
import profileNavMiddleware from '~publish/legacy/profile-nav/middleware'
import thirdpartyMiddleware from '~publish/legacy/thirdParty/middleware'
import profilesMiddleware from '~publish/legacy/profiles/middleware'
import orgMiddleware from '~publish/legacy/organizations/middleware'
import userMiddleware from '~publish/legacy/user/middleware'

// @ts-expect-error TS(7006) FIXME: Parameter 'history' implicitly has an 'any' type.
export const getMiddleware = (routerMiddleware) => [
  routerMiddleware,
  asyncDataFetchMiddleware,
  i18nMiddleware,
  profileSidebarMiddleware,
  bootstrapMiddleware,
  userMiddleware,
  orgMiddleware,
  profilesMiddleware,
  queueMiddleware,
  generalSettingsMiddleware,
  pusherSyncMiddleware,
  notificationsMiddleware,
  modalsMiddleware,
  maintenanceRedirectMiddleware,
  draftsMiddleware,
  notificationsProviderMiddleware,
  profilesDisconnectedModalMiddleware,
  thirdpartyMiddleware,
  campaignFormMiddleware,
  campaignMiddleware,
  campaignsListMiddleware,
  deleteCampaignModalMiddleware,
  trialCompleteModalMiddleware,
  hashtagGroupsMiddleware,
  segmentTrackingMiddleware,
  globalAccountMiddleware,
  temporaryBannerMiddleware,
  profileNavMiddleware,
  // Dynamic middlware insertion point (for lazy-loaded components)
  reduxDynamicMiddlewares,
]
